import { Injectable, inject } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { LanguageService } from './language.service';
import { Observable, catchError, map, of } from 'rxjs';
import { APP_LANGS } from './language.constants';
import { Langs } from './language.types';

@Injectable({
  providedIn: 'root',
})
export class LanguageGuard implements CanActivate {
  private router = inject(Router);
  private langService = inject(LanguageService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    const lang = route.params['lang'] as Langs | undefined;

    if (!lang || !APP_LANGS.includes(lang)) {
      const initLang = this.langService.getInitLang();
      const newUrl = `/${initLang}${state.url}`;
      this.router.navigateByUrl(newUrl, { replaceUrl: true });
      return this.useLang(initLang, false);
    }
    return this.useLang(lang, true);
  }

  private useLang(lang: Langs, result: boolean): Observable<boolean> {
    return this.langService.setLanguage(lang).pipe(
      map(() => result),
      catchError(() => of(false)),
    );
  }
}
